import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getIconSize } from '../utilities/index.js';
const Refresh = forwardRef(({ size = 'medium', fill = 'currentColor', ...props }, ref) => {
    const { iconWidth, iconHeight } = getIconSize(size);
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, fill: fill, width: iconWidth, height: iconHeight, "aria-hidden": ariaHidden, ...props, children: _jsx("path", { fillRule: "evenodd", d: "M12.545 4.292a6.25 6.25 0 1 0 3.01 8.574 1.25 1.25 0 1 1 2.22 1.147A8.75 8.75 0 1 1 16.25 3.876V2.5a1.25 1.25 0 1 1 2.5 0v4.167a1.25 1.25 0 0 1-1.25 1.25h-4.167a1.25 1.25 0 0 1 0-2.5h.916a6.3 6.3 0 0 0-1.704-1.125" }) }));
});
Refresh.displayName = 'Refresh';
Refresh.__iconComponentType = 'standard';
export default Refresh;
//# sourceMappingURL=Refresh.js.map